import React from 'react';
import './Footer.css';
// import bgFooter from '../../assets/images/footer-layout.jpg';

const Footer = () => {
  return (
    <footer className="footer">
      {/* <img src={bgFooter} alt="GK88" className="bg-footer" /> */}
    </footer>
  );
};

export default Footer;
